var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0534 5.49341L17.72 2.74674C16.96 2.46674 15.72 2.46674 14.96 2.74674L7.62671 5.49341C6.21338 6.02674 5.06671 7.68008 5.06671 9.18674V19.9867C5.06671 21.0667 5.77338 22.4934 6.64004 23.1334L13.9734 28.6134C15.2667 29.5867 17.3867 29.5867 18.68 28.6134L26.0134 23.1334C26.88 22.4801 27.5867 21.0667 27.5867 19.9867V9.18674C27.6 7.68008 26.4534 6.02674 25.0534 5.49341ZM20.9734 12.9601L15.24 18.6934C15.04 18.8934 14.7867 18.9867 14.5334 18.9867C14.28 18.9867 14.0267 18.8934 13.8267 18.6934L11.6934 16.5334C11.3067 16.1467 11.3067 15.5067 11.6934 15.1201C12.08 14.7334 12.72 14.7334 13.1067 15.1201L14.5467 16.5601L19.5734 11.5334C19.96 11.1467 20.6 11.1467 20.9867 11.5334C21.3734 11.9201 21.3734 12.5734 20.9734 12.9601Z",
    fill: "#78C257"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.66b5c595f55e40e5013f75356bbbdc80.svg";
export { ForwardRef as ReactComponent };